<template>
  <!-- Desktop Drawer -->
  <section
    v-if="!isMobile"
    class="bg-white h-full transition-all duration-200 ease-in-out border-solid border rounded-xl border-slate-300 p-1"
    :class="drawerClass"
  >
    <PrDrawerContent/>
  </section>

  <!-- Mobile Drawer -->
  <Drawer
    v-else
    v-model:visible="layoutStore.sidebarOpen"
    position="left"
    :modal="true"
    :dismissable="true"
    class="mobile-drawer !w-full"
  >
    <template #header>
      <div class="p-4 border-b">
        <h3 class="text-lg font-semibold">{{ t('general.navigation') }}</h3>
      </div>
    </template>
    <PrDrawerContent/>
  </Drawer>
</template>

<script setup lang="ts">
import PrDrawerContent from "@/components/PrDrawerContent.vue";
import Drawer from 'primevue/drawer';
import {computed, watch} from "vue";
import {useLayoutStore} from "@/stores/layoutStore";
import {useRoute} from "vue-router";
import useBreakpoints from "@/utilities/screen";
import {useI18n} from "vue-i18n";

const { t } = useI18n();

// State
const layoutStore = useLayoutStore();
const route = useRoute();
const { isMobile } = useBreakpoints();

// Computed
const drawerClass = computed(() => {
  if (layoutStore.sidebarOpen) {
    return 'w-64'
  } else {
    return 'w-[72px]'
  }
})

// Watch for route changes and close drawer on mobile
watch(route, () => {
  if (isMobile.value && layoutStore.sidebarOpen) {
    layoutStore.sidebarOpen = false;
  }
})
</script>

<style scoped>

</style>